module.exports = "/_next/static/images/login@2x-13136ca062b7edab776e219b6c14b3d7.png";